import usePrefetchProps from 'client/hooks/usePrefetchProps';
import React from 'react';

const withPrefetch = <T extends object>(
  Component: React.ComponentType<T>,
  ...args: Parameters<typeof usePrefetchProps>
) =>
  function WithPrefetch(props: T) {
    const prefetchProps = usePrefetchProps(...args);
    return <Component {...props} {...prefetchProps} />;
  };

export default withPrefetch;
